export type WorkflowStepId =
  | 'overview'
  | 'sites'
  | 'plan'
  | 'order'
  | 'cart'
  | 'status';

export interface WorkflowStep {
  id: WorkflowStepId;
  label: string;
  icon: string;
}

export const WORKFLOW_STEPS: WorkflowStep[] = [
  { id: 'overview', label: 'Overview', icon: 'dashboard' },
  { id: 'sites', label: 'Explore Sites', icon: 'language' },
  { id: 'plan', label: 'Create Order', icon: 'assignment' },
  { id: 'order', label: 'Place Order', icon: 'inventory_2' },
  { id: 'cart', label: 'Cart & Checkout', icon: 'shopping_cart' },
  { id: 'status', label: 'Order Status', icon: 'monitor_heart' },
];

export interface SelectedClient {
  id: string;
  name: string;
}

export interface SelectedProject {
  id: string;
  projectName: string;
  clientId: string;
  clientName: string;
  color: string;
}

export const PROJECT_COLORS = [
  '#2563eb',
  '#16a34a',
  '#7c3aed',
  '#d97706',
  '#dc2626',
  '#0891b2',
];

export function projectColor(index: number): string {
  return PROJECT_COLORS[index % PROJECT_COLORS.length];
}

export function clientInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}
